import { Reveal } from "./Reveal";

const IMG =
  "https://images.unsplash.com/photo-1519003722824-194d4455a60c?auto=format&fit=crop&w=1400&q=80";

const chapters = [
  {
    n: "01",
    title: "The Highway Reality",
    body: "Owner-operators belong on the road — not drowning in load boards, broker hold music, and rate confirmation PDFs at midnight.",
  },
  {
    n: "02",
    title: "Uncompromising Rates",
    body: "We communicate and negotiate with brokers on your behalf, inside the parameters you set for your business. Every cent per mile matters.",
  },
  {
    n: "03",
    title: "True Transparency",
    body: "A flat 9% fee on loads we dispatch. Weekly summaries of every load and the gross revenue behind it. No hidden anything.",
  },
];

export const Manifesto = () => (
  <section id="about" className="py-28 sm:py-36" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-neutral-500 mb-4">
          Chapter — Who We Are
        </p>
        <h2 className="font-display font-bold uppercase tracking-tight leading-none text-3xl sm:text-5xl lg:text-6xl max-w-4xl">
          More than dispatch.
          <br />
          <span className="text-neutral-500">A partner behind the wheel.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <div className="lg:col-span-7 flex flex-col">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.12}>
              <div
                className="group border-t border-white/15 py-10 grid sm:grid-cols-[90px_1fr] gap-4 sm:gap-8 hover:bg-white/[0.03] transition-colors duration-500 px-2 -mx-2"
                data-testid={`manifesto-chapter-${c.n}`}
              >
                <span className="font-display font-extrabold text-4xl sm:text-5xl text-white/15 group-hover:text-white/50 transition-colors duration-500">
                  {c.n}
                </span>
                <div>
                  <h3 className="font-display font-bold uppercase tracking-tight text-xl sm:text-2xl mb-3">
                    {c.title}
                  </h3>
                  <p className="text-neutral-400 leading-relaxed max-w-xl">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-white/15" />
        </div>

        <Reveal delay={0.2} className="lg:col-span-5 lg:sticky lg:top-28">
          <div className="relative overflow-hidden border border-white/10 group" data-testid="manifesto-image-frame">
            <img
              src={IMG}
              alt="Truck driving a mountain highway at night"
              className="w-full aspect-[4/5] object-cover grayscale transition-transform duration-[1.2s] ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B]/80 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-400">
                You drive. We handle the details.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
